export enum ApiMethodIconSize {
  Default = 'default',
  Large = 'large',
}
